import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: '',
    templateUrl: './group-hs-cust-search.html',
})
export class GroupHSCustSearchComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
    requestTypeMList: any[] = [];
    requestTypesSelected: string[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };

    customerCode: string = "";
    groupHSCode: string = "";
    

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);


    }

    ngOnDestroy() {
    }

    ngOnInit() {
         this.onSearch();

    }

    onSearch() {
        let params = new UrlParams();
        params.add('customerCode', this.customerCode);
        params.add('groupHScode', this.groupHSCode);


        this.gridData = this.http.getByManager(`api/GroupHSCustMatrix/GetPage?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('customerCode', this.customerCode);
        params.add('groupHScode', this.groupHSCode);
        this.waiting = true;
        this.http.download(`api/GroupHSCustMatrix/GetPage?${params.toString()}`, res => {
            let fileNameExport = 'CRM_GroupHS-Customer_Matrix.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        this.dlgImport.show('api/GroupHSCustMatrix/Import', null, res => {
            this.grid.refresh();
        });
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/GroupHSCustMatrix/Remove/${id}`, res => {
                this.grid.refresh();
            });
        });
    }

    addNew() {
        this.router.navigate(['/group-hs-cust-detail']);
    }


}
